import { useEffect, useRef, useState } from "react";
import { Html5Qrcode } from "html5-qrcode";

export const QrScanner = ({ onScan }) => {
  const cb = useRef(onScan);
  const [error, setError] = useState("");
  cb.current = onScan;

  useEffect(() => {
    const scanner = new Html5Qrcode("qr-reader");
    let started = false;
    scanner
      .start({ facingMode: "environment" }, { fps: 10, qrbox: 240 }, (text) => cb.current(text), () => {})
      .then(() => { started = true; })
      .catch(() => setError("Couldn't open the camera. Allow camera access or type the code instead."));
    return () => {
      if (started) scanner.stop().then(() => scanner.clear()).catch(() => {});
    };
  }, []);

  return (
    <div>
      <div id="qr-reader" data-testid="checkin-qr-reader" className="rounded-xl overflow-hidden border border-[#222634] max-w-sm" />
      {error && <p className="text-sm text-red-300 mt-2" data-testid="checkin-camera-error">{error}</p>}
    </div>
  );
};
